import * as React from "react";
import { Link } from "react-router-dom";
import Spinner from "../../components/Spinner";
import { ScaleUploadImg } from "../../components/ScaleUploadImg";

class ManageFishDetailScreen extends React.Component {
  constructor(props) {
    super(props);
    let params = props.location.fish;
    if (!params) params = { amount: { kg: true, quantity: false } };
    this.state = params;
  }

  componentWillReceiveProps(nextProps) {
    const { message } = nextProps.app;
    if (message.length > 0 && message !== "{ok}")
      setTimeout(() => {
        this.props.appMessage("");
      }, 6000);
    else if (message === "{ok}") {
      this.props.appMessage("");
      this.props.history.goBack();
    }
  }

  renderInput = ({ fieldName, value, label, secure = false }) => {
    return (
      <div>
        <label htmlFor="exampleInputEmail1">{label}</label>
        <input
          type={secure ? "password" : "text"}
          className="form-control"
          placeholder={label}
          onChange={event => this.setState({ [fieldName]: event.target.value })}
          defaultValue={value}
        />
      </div>
    );
  };

  renderTextarea = ({ fieldName, value, label }) => {
    return (
      <div>
        <label htmlFor="exampleInputEmail1">{label}</label>
        <textarea
          className="form-control"
          placeholder={label}
          onChange={event => this.setState({ [fieldName]: event.target.value })}
          defaultValue={value ? value.replace(/<br\s*[/]?>( |)/gi, "\n") : ""}
        />
      </div>
    );
  };

  deleteFishWithAlert = () => {
    if (
      window.confirm("Usunięcie ryby może spowodować problemy na targu rybnym")
    )
      this.props.deleteFish(this.state.id);
  };

  addOrUpdateFish = () => {
    if (this.state.id) this.props.updateFishData(this.state);
    else this.props.addNewFish(this.state);
  };

  isDisabled() {
    const { name } = this.state;

    if (!name || !name.length) return true;
    else return false;
  }

  _setFishAmount(value) {
    if (value === 0) this.setState({ amount: { kg: true, quantity: false } });
    else this.setState({ amount: { kg: false, quantity: true } });
  }

  render() {
    let { id, name, description, protectionTime, amount } = this.state;

    if (this.props.app.loading) return <Spinner />;
    return (
      <div>
        {this.props.app.message.length > 0 ? (
          <div className="alert alert-danger">{this.props.app.message}</div>
        ) : null}

        {id && (
          <Link
            className="btn btn-primary btn-sm btn-block mb-3"
            disabled={this.isDisabled()}
            to={{
              pathname: "manage-fish-recipe",
              ...this.state
            }}
          >
            Sprawdź przepisy
          </Link>
        )}

        <form>
          {this.renderInput({ fieldName: "name", value: name, label: "Nazwa" })}
          <div className="form-group">
            <label>W jakich jednostkach sprzedawana jest ryba</label>
            <select
              className="form-control"
              onChange={v => this._setFishAmount(v)}
            >
              <option value="0" selected={amount.kg === true}>
                Kilogramy
              </option>
              <option value="1" selected={amount.quantity === true}>
                Sztuki
              </option>
            </select>
          </div>

          {this.renderTextarea({
            fieldName: "description",
            value: description,
            label: "Opis"
          })}
          {this.renderTextarea({
            fieldName: "protectionTime",
            value: protectionTime,
            label: "Okres ochronny"
          })}

          <div className="my-3">
            <label className="w-100">Zdjęcie ryby</label>
            {this.state.img && <img alt="" src={this.state.img} />}
            <ScaleUploadImg
              maxHeight={300}
              maxWidth={300}
              onChangePhoto={photo => this.setState({ img: photo })}
            />
          </div>

          <button
            type="submit"
            className="btn btn-primary mt-2"
            disabled={this.isDisabled()}
            onClick={this.addOrUpdateFish}
          >
            {id ? "Aktualizuj" : "Dodaj"}
          </button>
        </form>

        {id && (
          <button
            className="btn btn-primary mt-2"
            disabled={this.isDisabled()}
            onClick={this.deleteFishWithAlert}
          >
            Usuń rybę
          </button>
        )}
      </div>
    );
  }
}

export default ManageFishDetailScreen;



// WEBPACK FOOTER //
// ./src/screens/ManageFish/ManageFishDetailScreen.js